<template>
    <transition name="bounce">
        <div v-show="showFlag" class="food" ref="food">
            <div class="food-content">
                <div class="image-header">
                    <img :src="getImgUrl(food.foodImage, 0)" style="background-size: cover">
                </div>
                <div class="back-btn">
                    <img src="../assets/image/back-btn.png" @click="hideFood" />
                </div>
                <div class="content">
                    <h1 class="title">{{ food.foodName }}</h1>
                    <div class="detail">
                    </div>
                    <div class="price">
                        <span class="now">{{ Number(food.price * food.actDiscount).toFixed(0) }}
                            {{ seller.unit }}</span><span class="old" v-show="food.oldPrice">{{ food.price }}
                            {{ seller.unit }}</span>
                    </div>
                    <div class="cartcontrol-wrapper">
                        <cartcontrol :food="food" v-show="food.childIds == null" :add-type="addType"></cartcontrol>
                    </div>
                </div>
                <div class="split" v-show="food.description"></div>
                <div class="info" v-show="food.description">
                    <h1 class="title">Desciption</h1>
                    <p class="text" v-html="food.description"></p>
                </div>
                <div class="info">
                    <h1 class="title">{{ $t('orderList.remark') }}</h1>
                    <mu-text-field multi-line :rows="3" :rows-max="6" v-model="food.remark"
                        style="margin-bottom: 0px; font-size: 12px;width:100%;"></mu-text-field><br />
                    <mu-button flat color="rgb(218, 91, 58)" @click="clickTaste(item)" v-for="(item, index) in tasteList"
                        :key="index" style="font-size:12px;">{{ item.tasteName }}</mu-button>
                </div>
            </div>
            <div style="width:100%;text-align:center;margin-bottom:10px;">
                <mu-button small color="primary" style="text-transform:unset;"
                    @click="hideFood">{{ $t('common.close') }}</mu-button>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import BScroll from 'better-scroll'
import { eventBus } from '../utils/event-bus'
import cartcontrol from '../components/CartControl.vue'
import { formatDate } from '../utils/formatDate'

const ALL = 2

export default {
    props: {
        food: {
            type: Object
        },
        addType: {
            type: Boolean
        }
    },
    data() {
        return {
            showFlag: false,
            selectType: ALL,
            onlyContent: true,
            tasteList: [],
            seller: {}
        }
    },
    mounted() {
        this.seller = JSON.parse(window.localStorage.getItem('seller') || '{}');
        this.getFoodTasteList();
    },
    methods: {
        show() {
            this.showFlag = true
            this.$nextTick(() => {
                if (!this.foodScroll) {
                    this.foodScroll = new BScroll(this.$refs.food, {
                        click: true
                    })
                } else {
                    this.foodScroll.refresh()
                }
            })
        },
        hideFood() {
            this.showFlag = false
        },
        addFirst(event) {
            this.$nextTick(() => {
                eventBus.$emit('addcart', event.target)
            })
            Vue.set(this.food, 'Quantity', 1)
        },
        selecttype(type) {
            this.selectType = type
            this.$nextTick(() => {
                this.foodScroll.refresh()
            })
        },
        content() {
            this.onlyContent = !this.onlyContent
            this.$nextTick(() => {
                this.foodScroll.refresh()
            })
        },
        needShow(type, text) {
            if (this.onlyContent && !text) {
                return false
            }
            if (this.selectType === ALL) {
                return true
            } else {
                return type === this.selectType
            }
        },
        getFoodTasteList() {
            this.$get('QRCodeOrder/GetFoodTasteList', {})
                .then(response => {
                    if (response.code == 200) {
                        this.tasteList = response.data;
                    } else {
                        this.$alert('The web cannot be accessed, please contact the manager!', 'Alert');
                    }
                });
        },
        getImgUrl(image, w = 0) {
            if (image == undefined || image == 'undefined' || image == null || image == '') {
                return '../static/img/default.png';
            }
            if (w == 0) {
                return this.global.baseUrl + "uploads/" + image
            }
            return this.global.baseUrl + "api/images/" + w + "/" + image
        },
        clickTaste(item) {
            this.food.remark = this.food.remark + item.tasteName;
        },
    },
    filters: {
        formatDate(time) {
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd hh:mm')
        }
    },
    components: {
        cartcontrol
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
    .food {
        max-width: 100%;
        position: fixed;
        width: 100%;
        z-index: 900;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 48px;
        background: #fff;
       overflow-y:scroll;
    }

        .food.bounce-enter-active {
            -webkit-animation: bounce-in 0.3s;
            animation: bounce-in 0.3s;
        }

        .food.bounce-leave-active {
            animation: bounce-in 0.3s reverse;
        }

        .food .food-content .image-header {
            position: relative;
            width: 100%;
            height: 260px;
          
        }

            .food .food-content .image-header img {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 260px;
                object-fit: contain;
            }

            .food .food-content .image-header .back {
                position: fixed;
                top: 12px;
                left: 0;
            }

                .food .food-content .image-header .back .icon-close {
                    display: inline-block;
                    padding: 10px;
                    color: #000;
                    font-size: 20px;
                }

        .food .food-content .content {
            position: relative;
            padding: 18px;
        }

            .food .food-content .content .title {
                font-size: 14px;
                line-height: 14px;
                font-weight: 700;
                color: #07111b;
                margin-bottom: 8px;
            }

            .food .food-content .content .detail {
                font-size: 10px;
                line-height: 10px;
                color: #93999f;
                margin-bottom: 18px;
            }

                .food .food-content .content .detail .sell-count {
                    margin-right: 12px;
                }

            .food .food-content .content .price {
                font-size: 14px;
                font-weight: 700;
                line-height: 24px;
                color: #f01414;
            }

                .food .food-content .content .price .old {
                    font-size: 10px;
                    font-weight: 700;
                    line-height: 24px;
                    color: #938f9f;
                    text-decoration: line-through;
                    margin-left: 10px;
                }

            .food .food-content .content .cartcontrol-wrapper {
                position: absolute;
                right: 12px;
                bottom: 12px;
            }

            .food .food-content .content .buy {
                position: absolute;
                right: 18px;
                bottom: 18px;
                padding: 0 12px;
                height: 24px;
                line-height: 24px;
                background: #da5b3a;
                font-size: 10px;
                color: #fff;
                border-radius: 12px;
                opacity: 1;
            }

                .food .food-content .content .buy.fade-enter-active,
                .food .food-content .content .buy.fade-leave-active {
                    -webkit-transition: opacity 0.5s;
                    transition: opacity 0.5s;
                }

                .food .food-content .content .buy.fade-enter,
                .food .food-content .content .buy.fade-leave-to {
                    opacity: 0;
                }

        .food .food-content .split {
            height: 5px;
            background: #f2f2f2;
        }

        .food .food-content .info {
            padding-left: 18px;
            padding-right: 18px;
            padding-top:5px;
            padding-bottom:10px;
        }

            .food .food-content .info .title {
                font-size: 14px;
                line-height: 14px;
                margin-bottom: 6px;
                color: #07111b;
                font-weight: 500;
            }

            .food .food-content .info .text {
                padding: 0 8px;
                font-size: 12px;
                font-weight: 200;
                color: #4d555d;
                line-height: 24px;
            }

        .food .food-content .rating {
            padding: 18px 18px 12px 18px;
            border-bottom: 1px solid rgba(7,17,27,0.1);
        }

            .food .food-content .rating .title {
                font-size: 14px;
                line-height: 14px;
                margin-bottom: 6px;
                color: #07111b;
                font-weight: 500;
            }

        .food .food-content .rating-wrapper {
            padding: 0 18px;
        }

            .food .food-content .rating-wrapper .rating-item {
                padding: 16px 0;
                position: relative;
            }

                .food .food-content .rating-wrapper .rating-item:after {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    border-top: 1px solid rgba(7,17,27,0.1);
                    content: '';
                }

                .food .food-content .rating-wrapper .rating-item .user {
                    position: absolute;
                    right: 0;
                    top: 16px;
                    font-size: 0;
                }

                    .food .food-content .rating-wrapper .rating-item .user .name {
                        display: inline-block;
                        margin-right: 6px;
                        font-size: 10px;
                        line-height: 12px;
                        color: #93999f;
                        vertical-align: top;
                    }

                    .food .food-content .rating-wrapper .rating-item .user .avatar {
                        border-radius: 50%;
                        vertical-align: top;
                    }

                .food .food-content .rating-wrapper .rating-item .time {
                    font-size: 10px;
                    color: #93999f;
                    line-height: 12px;
                }

                .food .food-content .rating-wrapper .rating-item .text {
                    margin-top: 6px;
                    font-size: 0;
                }

                    .food .food-content .rating-wrapper .rating-item .text .icon-thumb_down {
                        display: inline-block;
                        margin-right: 4px;
                        font-size: 12px;
                        color: #93999f;
                        line-height: 16px;
                        vertical-align: top;
                    }

                    .food .food-content .rating-wrapper .rating-item .text .icon-thumb_up {
                        display: inline-block;
                        margin-right: 4px;
                        font-size: 12px;
                        color: #00a0dc;
                        line-height: 16px;
                        vertical-align: top;
                    }

                    .food .food-content .rating-wrapper .rating-item .text .text-content {
                        font-size: 12px;
                        color: #07111b;
                        line-height: 16px;
                    }

            .food .food-content .rating-wrapper .no-rating {
                padding: 12px 0;
                font-size: 12px;
                color: #93999f;
            }

    .back-btn {
        position: absolute;
        top:15px;
        left: 15px;
        width: 32px;
        height: 32px;
        z-index: 999;
    }
    .back-btn img{
        top: 15px;
        left: 15px;
        width: 32px;
        height: 32px;
        z-index: 999;
    }

    @-webkit-keyframes bounce-in {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }

    @keyframes bounce-in {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Food.vue